export type Region = {
  name: string;
  monolithDomain: string;
  relayDomain: string;
  flag: string;
};

export const Regions: Region[] = [
  {
    name: "United States",
    monolithDomain: "https://monolith-app.monolithforensics.com",
    relayDomain: "https://relay-app.monolithforensics.com",
    flag: "🇺🇸",
  },
  {
    name: "United Kingdom",
    monolithDomain: "https://monolith-app.monolithforensics.co.uk",
    relayDomain: "https://relay-app.monolithforensics.co.uk",
    flag: "🇬🇧",
  },
  {
    name: "Blue Lights Digital UK",
    monolithDomain: "https://monolith-app.bluelightsdigital.com",
    relayDomain: "https://relay-app.bluelightsdigital.com",
    flag: "🇬🇧",
  },
  {
    name: "Canada",
    monolithDomain: "https://monolith-can.monolithforensics.com",
    relayDomain: "https://relay-can.monolithforensics.com",
    flag: "🇨🇦",
  },
  {
    name: "Australia",
    monolithDomain: "https://monolith-syd.monolithforensics.com",
    relayDomain: "https://relay-syd.monolithforensics.com",
    flag: "🇦🇺",
  },
  {
    name: "Staging",
    monolithDomain: "https://monolith-staging.monolithforensics.com",
    relayDomain: "https://relay-staging.monolithforensics.com",
    flag: "🇺🇸",
  },
];
